import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as api from "../actions"
import { CONFIGMASTER } from "../apiServices/endpoints";

const initialState = {
  configData: [],
  isLoading: true,
  error: "",
};

export const getconfigList = createAsyncThunk(
  "List/getConfigList",
  async () => {
    const response = await api.get(`${CONFIGMASTER}/getAll`);
    return response;
  }
);

export const configList = createSlice({
  name: "configList",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getconfigList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getconfigList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = "";
        state.configData = action.payload;
      })
      .addCase(getconfigList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.configData = [];
      });
  },
});

export default configList.reducer;
